@if (nutrientAdviceData$ | async; as adviceData) {
  @if (isSuccessResponse(adviceData)) {
    <mat-card class="advice-card">
      <mat-card-header class="table-header flex--row flex--justify-space-between flex--align-center">
        <mat-card-title class="table-title">{{ 'BFP.UI.FertilizerAdvice.Title' | translate }}</mat-card-title>
        <button
          mat-icon-button
          (click)="redirectToELearning()"
          [title]="'BFP.UI.FertilizerAdvice.E-learning' | translate"
        >
          <mat-icon style="color: white">info_outline</mat-icon>
        </button>
      </mat-card-header>

      @if (adviceData.nutrientAdviceCalculation && adviceData.nutrientAdviceCalculation?.n1?.sampleDate) {
        <mat-tab-group
          [@.disabled]="true"
          [selectedIndex]="selectedTabIndex"
          (selectedIndexChange)="selectTab($event)"
          animationDuration="300ms"
        >
          <mat-tab
            [label]="
              (adviceData.nutrientAdviceCalculation.n1.sampleDate! | date: 'mediumDate' : undefined : locale) ?? ''
            "
          >
            <app-nutrient-advice-tab
              [nutrientGroup]="adviceData.nutrientAdviceCalculation?.n1"
              [isOutdated]="selectedTabIndex !== newestTabIndex"
              sampleMoment="n1"
            >
            </app-nutrient-advice-tab>
          </mat-tab>

          @if (adviceData.nutrientAdviceCalculation.n2?.sampleDate) {
            <mat-tab
              [label]="
                (adviceData.nutrientAdviceCalculation.n2.sampleDate! | date: 'mediumDate' : undefined : locale) ?? ''
              "
            >
              <app-nutrient-advice-tab
                [nutrientGroup]="adviceData.nutrientAdviceCalculation?.n2"
                [isOutdated]="selectedTabIndex !== newestTabIndex"
                sampleMoment="n2"
              >
              </app-nutrient-advice-tab>
            </mat-tab>
          }
          @if (adviceData.nutrientAdviceCalculation.n3?.sampleDate) {
            <mat-tab
              [label]="
                (adviceData.nutrientAdviceCalculation.n3.sampleDate! | date: 'mediumDate' : undefined : locale) ?? ''
              "
            >
              <app-nutrient-advice-tab
                [nutrientGroup]="adviceData.nutrientAdviceCalculation?.n3"
                [isOutdated]="selectedTabIndex !== newestTabIndex"
                sampleMoment="n3"
              >
              </app-nutrient-advice-tab>
            </mat-tab>
          }
        </mat-tab-group>
      } @else {
        <!-- No nutrient advice calculation data -->
        <mat-card-content>
          <agr-notification-empty
            [isEmpty]="true"
            [emptyDescription]="'BFP.UI.FertilizerAdvice.NoCalculations' | translate"
            [showEmptyAction]="false"
            emptyActionColor="primary"
          />
        </mat-card-content>
      }
    </mat-card>

    <div class="disclaimer">
      {{ 'BFP.UI.FertilizerAdvice.Disclaimer' | translate }}
    </div>
  } @else {
    <!-- Error state -->
    <mat-card class="error-card">
      <mat-card-content>
        <agr-notification-empty
          [isEmpty]="true"
          [emptyDescription]="
            (adviceData.title
              ? 'BFP.Validation.Backend.' + adviceData.status + '.AdviceCalculation'
              : 'BFP.Validation.Backend.FailedToGetAdviceCalculations'
            ) | translate
          "
          [showEmptyAction]="false"
          emptyActionColor="primary"
        />
      </mat-card-content>
    </mat-card>
  }
} @else {
  <!-- Loading state -->
  <mat-card class="loading-card">
    <mat-card-content>
      <div class="loading-container">
        <mat-spinner diameter="40"></mat-spinner>
        <span>{{ 'BFP.UI.Loading' | translate }}</span>
      </div>
    </mat-card-content>
  </mat-card>
}
